<template>

	<div class="container main-content">
		<div class="row">
			<div class="col-12 col-sm-6">
				<div class="row mb-4">

					<div class="col-12 text-center pt-2 interac-logo">
						<img src="./../assets/img/interac.png" class="img-fluid" style="width: 42%">
					</div>


					<div class="col-12 col-md-10 offset-md-1 text-center mt-5">
						<h4 class="dark-highlight mb-5">Enter your email to receive funds by Interac E-Transfer.</h4>
						<input class="bitaddress form-control no-border-radius inline" 
							type="text" 
							ref="inputelem" 
							name="emtemail" 
							v-model="in_email" 
							:class="{'is-invalid': hasError}"
							:disabled="isProcessing"
							>
						<small class="error" v-if="hasError">{{ errorMessage }}</small>
					</div>
				</div>
				<div class="row">
					<div class="col-12 text-center">
						<p class="mb-4"><small>By clicking next, you agree that you have access to your personal email address. {{ $gstate.getMerchantName() }} is <b>not</b> responsible for your funds once we've sent the funds to your email.</small></p>
						<a href="#" id="address-input-next" class="btn next-btn" v-on:click.prevent="saveEmailAddress" v-if="!isProcessing">NEXT</a>
						<a href="#" class="btn next-btn disabled" v-on:click.prevent="noop" v-if="isProcessing">PLEASE WAIT... <i class="fas fa-circle-notch fa-spin"></i></a>
					</div>
				</div>
			</div>
			<div class="col-12 mt-5 pt-sm-0 offset-sm-1 col-sm-5 info-text">

				<h5 class="mb-4">Stay informed</h5>
				<p class="mb-4">To learn more about Interac e-Transfer and all participating financial institutions, visit the <a target="_blank" href="https://www.interac.ca/en/consumers/products/interac-e-transfer/">Interac Website</a>.</p>

				<div class="col-12 text-left p-4 panel-warning text-warning">
					<p>
						<strong>Attention</strong>
					</p>
					<ol class="pl-3">
						<li class="mb-3">Please ensure your email address is accurate.  An incorrect email address may result in loss of funds.</li>
						<li>All funds must only be received by you personally. Be cautious of others asking you to use this service to pay them directly as this may indicate a scam.  <a v-if="$gstate.isCoincurve()" target="_blank" :href="$gstate.getSiteURL() + '/security-bulletin'">Read more</a>.</li>
					</ol>
					
				</div>
			</div>
		</div>
		
	</div>

</template>

<script>

import { eventBus } from './../main'

export default {
	data() {
		return {
			in_email: '',
			isProcessing: false,
			pq: this.$gstate.getFlowState(),
			hasError: false,
			errorMessage: '',
		}
	},
	computed: {
		
	},
	created(){
		eventBus.$on('nextScreen', this.saveEmailAddress);
		this.in_email = this.$gstate.getEmtEmailAddress();
	},
	beforeDestroy(){
		eventBus.$off('nextScreen', this.saveEmailAddress);
	},
	methods: {
		saveEmailAddress: function() {

			this.isProcessing = true;
			this.hasError = false;

			if (!this.in_email) {
				this.isProcessing = false;
				this.hasError = true;
				this.errorMessage = "Your email address is required.";
				return;
			}

			if(!this.validateEmail(this.in_email)){
				this.isProcessing = false;
				this.hasError = true;
				this.errorMessage = "Please provide a valid email address.";
				return;
			}

			var urlstr = this.$gstate.getApiBaseURL() + '/emtemail';
			this.axios.post(urlstr,{
				refId: this.$gstate.getRefId(),
				emtEmail: this.in_email,
			}, 
			this.$gstate.getAxiosHeaders()
			).then(response => {

					this.$gstate.log(response);
					this.isProcessing = false;
					
					this.$gstate.saveFlowStateAndProceed(response.data, this);


				})
				.catch(error => {

					this.$gstate.log("error:");
					this.$gstate.log(error.response);
					
					this.isProcessing = false;
					this.hasError = true;
					this.errorMessage = error.response.data.error.msg;
				});
		},
		validateEmail: function(emailAddress) 
		{
			if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(emailAddress)) {
				return true;
			}

			return false;
		}
	}
}
</script>
